import { FC, PropsWithChildren } from 'react';
import { Box, Column, Grid } from '@quinyx/ui';

import SideMenu from '../../../components/SideMenu';
import styles from './index.module.scss';
import ErrorBoundary from '../../../components/ErrorBoundary';
import { useSideMenuTree } from '@/hooks/navigation/useSideMenuTree';

const AsideLayout: FC<PropsWithChildren> = ({ children }) => {
  const menuTree = useSideMenuTree();

  return (
    <Grid data-testid="layout" columns={12} className={styles.layout}>
      <Column
        data-testid="layout-aside"
        span={2}
        className={styles.layout__asideColumn}>
        <Box as="aside" className={styles.layout__aside}>
          <SideMenu menuTree={menuTree} />
        </Box>
      </Column>
      <Column
        data-testid="layout-content"
        span={[12, 12, 10]}
        className={styles.layout__main}>
        <ErrorBoundary>
          <Box className={styles.layout__main__content}>{children}</Box>
        </ErrorBoundary>
      </Column>
    </Grid>
  );
};

export default AsideLayout;
